import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../context/commandsContext';
import useKeyPress from '../../hooks/useKeyPress';
import FullBodyContentView from '../views/fullBodyContentView';

function Licenses({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);

  return (
    <FullBodyContentView
      title="Licenses"
      fullCaption="Unique ID...........................0............  
      Permanent License Key....................
      None.................................................
      Expiration (days)..............................
      Licensed Features............................
      No Licensed Features......................
      
      "
    />
  );
}

export default Licenses;
